module.exports = __webpack_public_path__ + "img/home-icon.e90e6cbc.svg";